export const SET_ROLE = 'SET_ROLE';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_IS_INSTALL_APP = 'SET_IS_INSTALL_APP';
export const SET_IS_CHANGE_PROTOCOL = 'SET_IS_CHANGE_PROTOCOL';
export const SET_IS_MOBILE = 'SET_IS_MOBILE';
export const SET_IS_MOBILE_TOOLBAR_SQUEEZED = 'SET_IS_MOBILE_TOOLBAR_SQUEEZED';
export const SET_ACTIVE_MOBILE_TAB = 'SET_ACTIVE_MOBILE_TAB';
export const SET_CALIBRATION_TRIGGERED = 'SET_CALIBRATION_TRIGGERED';
export const SET_IS_HORIZONTAL = 'SET_IS_HORIZONTAL';
export const SET_IS_INTERLOCUTOR_HORIZONTAL = 'SET_IS_INTERLOCUTOR_HORIZONTAL';
export const SET_IS_HORIZONTAL_OPENED_FILES = 'SET_IS_HORIZONTAL_OPENED_FILES';
export const SET_IS_IPHONE_LOADER = 'SET_IS_IPHONE_LOADER';
export const SET_IS_DISABLED_CLICK_OUTSIDE = 'SET_IS_DISABLED_CLICK_OUTSIDE';
export const INCREASE_USER_RECORDINGS = 'INCREASE_USER_RECORDINGS';
export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';
export const SET_DID_LOGIN = 'SET_DID_LOGIN';
export const SET_OPEN_MODAL_COUNT = 'SET_OPEN_MODAL_COUNT';
